import type { NextPage, GetStaticProps } from 'next';

import PageService from 'services/PageService/PageService';
import CareerListSection from 'blocks/CareerListSection/CareerListSection';
import { IGenericPage, ICareerPage } from 'types/interfaces';
import GlobalLayout from 'blocks/Layouts/GlobalLayout';
import { navigationPaths, PAGE_INVALIDATION_INTERVAL } from 'data/constants';
import PageLayout from 'blocks/Layouts/page-layout';
import StaticPageContent, {
  StaticPageContentProps,
} from 'data/staticPageContent';

import careerImage from 'assets/careers/header-image.jpg';

interface ICareers extends IGenericPage, ICareerPage {
  pageContent: StaticPageContentProps;
}

const Careers: NextPage<ICareers> = ({
  globalLayoutProps,
  careers,
  pageContent,
}) => {
  return (
    <GlobalLayout {...globalLayoutProps}>
      <PageLayout {...pageContent} image={careerImage}>
        <CareerListSection
          careers={careers}
          countryCodes={globalLayoutProps.countryCodes}
        />
      </PageLayout>
    </GlobalLayout>
  );
};

export default Careers;

export const getStaticProps: GetStaticProps = async () => {
  const genericPageProps = await PageService.getGenericPageProps({
    navPath: navigationPaths.CAREERS,
  });
  const careerPageProps = await PageService.getCareerPageProps();
  const pageContent = StaticPageContent[navigationPaths.CAREERS];
  return {
    props: {
      ...genericPageProps,
      ...careerPageProps,
      pageContent,
    },
    revalidate: PAGE_INVALIDATION_INTERVAL,
  };
};
